export const NEW_SEMANTIC_ANALYSIS_MIN_DATE = new Date('2025-01-01');

export const EMPTY_KEY = 'empty';
